import { useEffect, useRef, useState } from 'react';

import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import { SocialSharingOptions } from 'src/types/SocialSharingOptions';

import { Button } from 'src/components/basicContent/_Button/Button';
import MicroModal from 'src/components/basicContent/_MicroModal/_MicroModal';

import ShareIconOutlineSvg from 'public/icons/ShareIconOutline.svg';

import ShareOptions from './_ShareOptions/_ShareOptions';

import styles from './ShareButton.module.css';

type ShareButtonProps = {
	shareButtonText?: Field<string>;
	shareButtonToolTip?: Field<string>;
	shareOptions: SocialSharingOptions;
	noShareOptions?: Field<string>;
	shareTitle: string;
	shareUrl: string;
	alignLeft?: boolean;
	toolbarIconSize?: boolean;
	topicsPageShare?: boolean;
};

export function ShareButton(props: ShareButtonProps) {
	const [isActive, setIsActive] = useState(false);
	const trigger = useRef<HTMLButtonElement>(null);
	const modalRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		function handleClickOutside(event: MouseEvent) {
			if (
				modalRef.current &&
				!modalRef.current.contains(event.target as Node) &&
				trigger.current &&
				!trigger.current.contains(event.target as Node)
			) {
				setIsActive(false);
			}
		}

		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	const className = props.topicsPageShare ? styles.topicsPageShare : props.toolbarIconSize ? styles.toolbarModal : styles.modal;

	return (
		<div className={styles.shareContainer} ref={modalRef}>
			<Button
				title={props.shareButtonToolTip?.value}
				buttonRef={trigger}
				className={`${styles.shareButton} link linkOffset linkHoverWeighted`}
				onClick={() => setIsActive(!isActive)}
			>
				<span>
					<ShareIconOutlineSvg
						alt={props.shareButtonText?.value}
						className={props.toolbarIconSize || props.topicsPageShare ? styles.toolbarShareIcon : styles.shareIcon}
					/>
					{props.shareButtonText?.value && <span className={styles.shareButtonText}>{props.shareButtonText?.value}</span>}
				</span>
			</Button>

			<MicroModal modalState={isActive} closeModal={() => setIsActive(false)} className={className}>
				<ShareOptions
					shareTitle={props.shareTitle}
					shareUrl={props.shareUrl}
					shareOptions={props.shareOptions}
					noShareOptions={props.noShareOptions}
				/>
			</MicroModal>
		</div>
	);
}
